import * as actionTypes from '../constants/actionTypes';
import { updateObject } from '../../../../shared/utils/utility';

const initialState = {
  signatureBytes: null,
  signatureBytesError: null,
  signatureBytesLoading: false,
  signatureStyleLookup: null,
  signatureStyleLookupError: null,
  signatureStyleLookupLoading: false,
  generatedSignature: null,
  generatedSignatureError: null,
  generatedSignatureLoading: false,
  saveSignatureResult: null,
  saveSignatureError: null,
  saveSignatureLoading: false,
  signatureName: null,
  signatureNameError: null,
  signatureNameLoading: false,
  originalSignatureBytes: null,
  originalSignatureBytesError: null,
  originalSignatureBytesLoading: false,
};

const getSignatureBytesStart = (state, action) => {
  return updateObject(state, {
    signatureBytes: null,
    signatureBytesError: null,
    signatureBytesLoading: true,
  });
};

const getSignatureBytesSuccess = (state, action) => {
  return updateObject(state, {
    signatureBytes: action.data,
    signatureBytesError: null,
    signatureBytesLoading: false,
  });
};

const getSignatureBytesFail = (state, action) => {
  return updateObject(state, {
    signatureBytes: null,
    signatureBytesError: action.error,
    signatureBytesLoading: false,
  });
};

const getSignatureStyleLookupStart = (state, action) => {
  return updateObject(state, {
    signatureStyleLookup: null,
    signatureStyleLookupError: null,
    signatureStyleLookupLoading: true,
  });
};

const getSignatureStyleLookupSuccess = (state, action) => {
  return updateObject(state, {
    signatureStyleLookup: action.data,
    signatureStyleLookupError: null,
    signatureStyleLookupLoading: false,
  });
};

const getSignatureStyleLookupFail = (state, action) => {
  return updateObject(state, {
    signatureStyleLookup: null,
    signatureStyleLookupError: action.error,
    signatureStyleLookupLoading: false,
  });
};

const getGeneratedSignatureStart = (state, action) => {
  return updateObject(state, {
    generatedSignature: null,
    generatedSignatureError: null,
    generatedSignatureLoading: true,
  });
};

const getGeneratedSignatureSuccess = (state, action) => {
  return updateObject(state, {
    generatedSignature: action.data,
    generatedSignatureError: null,
    generatedSignatureLoading: false,
  });
};

const getGeneratedSignatureFail = (state, action) => {
  return updateObject(state, {
    generatedSignature: null,
    generatedSignatureError: action.error,
    generatedSignatureLoading: false,
  });
};

const saveSignatureStart = (state, action) => {
  return updateObject(state, {
    saveSignatureResult: null,
    saveSignatureError: null,
    saveSignatureLoading: true,
  });
};

const saveSignatureSuccess = (state, action) => {
  return updateObject(state, {
    saveSignatureResult: action.data,
    saveSignatureError: null,
    saveSignatureLoading: false,
  });
};

const saveSignatureFail = (state, action) => {
  return updateObject(state, {
    saveSignatureResult: null,
    saveSignatureError: action.error,
    saveSignatureLoading: false,
  });
};

const getSignatureNameStart = (state, action) => {
  return updateObject(state, {
    signatureName: null,
    signatureNameError: null,
    signatureNameLoading: true,
  });
};

const getSignatureNameSuccess = (state, action) => {
  return updateObject(state, {
    signatureName: action.data,
    signatureNameError: null,
    signatureNameLoading: false,
  });
};

const getSignatureNameFail = (state, action) => {
  return updateObject(state, {
    signatureName: null,
    signatureNameError: action.error,
    signatureNameLoading: false,
  });
};

const getOriginalSignatureBytesStart = (state, action) => {
  return updateObject(state, {
    originalSignatureBytes: null,
    originalSignatureBytesError: null,
    originalSignatureBytesLoading: true,
  });
};

const getOriginalSignatureBytesSuccess = (state, action) => {
  return updateObject(state, {
    originalSignatureBytes: action.data,
    originalSignatureBytesError: null,
    originalSignatureBytesLoading: false,
  });
};

const getOriginalSignatureBytesFail = (state, action) => {
  return updateObject(state, {
    originalSignatureBytes: null,
    originalSignatureBytesError: action.error,
    originalSignatureBytesLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SIGNATURE_GET_SIGNATURE_BYTES_START:
      return getSignatureBytesStart(state, action);
    case actionTypes.SIGNATURE_GET_SIGNATURE_BYTES_SUCCESS:
      return getSignatureBytesSuccess(state, action);
    case actionTypes.SIGNATURE_GET_SIGNATURE_BYTES_FAIL:
      return getSignatureBytesFail(state, action);

    case actionTypes.SIGNATURE_GET_SIGNATURE_STYLE_LOOKUP_START:
      return getSignatureStyleLookupStart(state, action);
    case actionTypes.SIGNATURE_GET_SIGNATURE_STYLE_LOOKUP_SUCCESS:
      return getSignatureStyleLookupSuccess(state, action);
    case actionTypes.SIGNATURE_GET_SIGNATURE_STYLE_LOOKUP_FAIL:
      return getSignatureStyleLookupFail(state, action);

    case actionTypes.SIGNATURE_GET_GENERATED_SIGNATURE_START:
      return getGeneratedSignatureStart(state, action);
    case actionTypes.SIGNATURE_GET_GENERATED_SIGNATURE_SUCCESS:
      return getGeneratedSignatureSuccess(state, action);
    case actionTypes.SIGNATURE_GET_GENERATED_SIGNATURE_FAIL:
      return getGeneratedSignatureFail(state, action);

    case actionTypes.SIGNATURE_SAVE_SIGNATURE_START:
      return saveSignatureStart(state, action);
    case actionTypes.SIGNATURE_SAVE_SIGNATURE_SUCCESS:
      return saveSignatureSuccess(state, action);
    case actionTypes.SIGNATURE_SAVE_SIGNATURE_FAIL:
      return saveSignatureFail(state, action);

    case actionTypes.SIGNATURE_GET_SIGNATURE_NAME_START:
      return getSignatureNameStart(state, action);
    case actionTypes.SIGNATURE_GET_SIGNATURE_NAME_SUCCESS:
      return getSignatureNameSuccess(state, action);
    case actionTypes.SIGNATURE_GET_SIGNATURE_NAME_FAIL:
      return getSignatureNameFail(state, action);

    case actionTypes.SIGNATURE_GET_ORIGINAL_SIGNATURE_BYTES_START:
      return getOriginalSignatureBytesStart(state, action);
    case actionTypes.SIGNATURE_GET_ORIGINAL_SIGNATURE_BYTES_SUCCESS:
      return getOriginalSignatureBytesSuccess(state, action);
    case actionTypes.SIGNATURE_GET_ORIGINAL_SIGNATURE_BYTES_FAIL:
      return getOriginalSignatureBytesFail(state, action);

    default:
      return state;
  }
};

export default reducer;
